import * as React from 'react'
import { LucideIcon, LucideIconName } from 'utils/lucideIcon'
import './searchResultRow.scss'

interface SearchResultRowProps {
    id: string
    iconName: LucideIconName
    title: string
    subtitle?: string
    hint?: string
    active: boolean
    onClick: () => void
    onMouseEnter: () => void
    rowRef: (element: HTMLDivElement | null) => void
}

export function SearchResultRow({
    id,
    iconName,
    title,
    subtitle,
    hint,
    active,
    onClick,
    onMouseEnter,
    rowRef,
}: SearchResultRowProps): JSX.Element {
    return (
        <div
            id={id}
            ref={rowRef}
            className={`global-search-row${active ? ' active' : ''}`}
            role="option"
            aria-selected={active}
            onClick={onClick}
            onMouseEnter={onMouseEnter}
        >
            <LucideIcon iconName={iconName} size={15} className="global-search-row-icon" />
            <div className="global-search-row-text">
                <div className="global-search-row-title">{title}</div>
                {subtitle && <div className="global-search-row-subtitle">{subtitle}</div>}
            </div>
            {hint && <div className="global-search-row-hint">{hint}</div>}
            <LucideIcon iconName="ArrowRight" size={13} className="global-search-row-arrow" />
        </div>
    )
}
